export function initializeInfiniteScroll(options) {
    var containerSelector = options.containerSelector, paginationSelector = options.paginationSelector, _a = options.offset, offset = _a === void 0 ? 200 : _a;
    var canBeLoaded = true;
    var loading = false;
    var mainContent = document.querySelector(containerSelector);
    var nextPageLink = document.querySelector("".concat(paginationSelector, " .next.page-numbers"));
    // Function to handle loading new posts
    function loadMorePosts() {
        if (nextPageLink && canBeLoaded && !loading) {
            canBeLoaded = false;
            loading = true;
            var xhr_1 = new XMLHttpRequest();
            xhr_1.open('GET', nextPageLink.href, true);
            xhr_1.onload = function () {
                if (xhr_1.status >= 200 && xhr_1.status < 400) {
                    // Create a temporary DOM element to extract the loaded content
                    var parser = new DOMParser();
                    var newDocument = parser.parseFromString(xhr_1.responseText, 'text/html');
                    // Get the new posts from the fetched page
                    var newPosts = newDocument.querySelectorAll("".concat(containerSelector, " .post-item"));
                    newPosts.forEach(function (post) {
                        mainContent === null || mainContent === void 0 ? void 0 : mainContent.appendChild(post);
                    });
                    // Update the next page link with the new one
                    nextPageLink = newDocument.querySelector("".concat(paginationSelector, " .next.page-numbers"));
                    canBeLoaded = !!nextPageLink;
                    loading = false;
                }
            };
            xhr_1.send();
        }
    }
    // Event listener to detect scroll
    window.addEventListener('scroll', function () {
        if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - offset &&
            canBeLoaded &&
            !loading) {
            loadMorePosts();
        }
    });
}
